<template>
	<div
		id="filter-header-container"
		class="filter-header"
	>
		<div
			v-if="elements.length"
			class="selected-options"
		>
			<ChipBase
				v-for="{ label, value } of elements"
				:key="value"
				:as="'div'"
				:with-delete="true"
				:thin="true"
				@click.stop="emits('removeSelection', value)"
				@delete-click.stop="emits('removeSelection', value)"
			>
				<template #label>
					{{ label }}
					<span
						v-if="value && !hideValue"
						class="selected-options--thin"
					>
						({{ value }})
					</span>
				</template>
			</ChipBase>
		</div>
		<slot />
	</div>
</template>

<script lang="ts" setup>
import ChipBase from '@lmt-rpb/Atoms/ChipBase/ChipBase.vue';
import type { LabelValue } from '@components/common/types';

const { elements, hideValue = false } = defineProps<{ elements: LabelValue[]; hideValue?: boolean }>();
const emits = defineEmits(['removeSelection']);
</script>

<style lang="scss" scoped>
#filter-header-container {
	overflow: auto;
}

.filter-header {
	display: flex;
	flex-direction: column;
}

:deep() {
	.chip-base {
		border-color: $chip-base-delete-icon;
		color: $chip-base-delete-icon;

		&__label {
			white-space: nowrap;

			@media (min-width: $breakpoint-extralarge) {
				white-space: break-spaces;
			}
		}
	}
}

.selected-options {
	display: flex;
	align-items: center;
	gap: 1.6em;
	row-gap: 0.8em;
	overflow: auto;
	padding: 0.8rem 1.6rem;
	box-shadow: 0.3rem 0.4rem 1.4rem 0 #6663;

	@media (min-width: $breakpoint-extralarge) {
		flex-wrap: wrap;
		overflow: unset;
		padding: 1.6rem;
	}

	&--thin {
		font-weight: $font-weight-regular;
	}
}
</style>
